import './AmbientUtility.css';

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { AmbientUtility } from './AmbientUtility';

const DELAY_HOURS = 1;
const DELAY_MS = DELAY_HOURS * 60 * 60 * 1000;

function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ?? false;
}

interface AmbientUtilityGateProps {
  size?: number;
}

export function AmbientUtilityGate({ size = 48 }: AmbientUtilityGateProps) {
  const [shouldRender, setShouldRender] = useState(false);
  const [flyingAway, setFlyingAway] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const reducedMotion = useMemo(() => prefersReducedMotion(), []);

  useEffect(() => {
    if (reducedMotion) return undefined;

    const timer = window.setTimeout(() => {
      setShouldRender(true);
    }, DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [reducedMotion]);

  const handleDismiss = useCallback(() => {
    setFlyingAway(true);

    setTimeout(() => {
      setShouldRender(false);
    }, 1500);
  }, []);

  if (!shouldRender) return null;

  return (
    <div
      ref={wrapperRef}
      className={`ambientUtilityWrap ${flyingAway ? 'flying-away' : ''}`}
      aria-hidden="true"
      title="Click to dismiss"
    >
      <AmbientUtility size={size} onDismiss={handleDismiss} />
    </div>
  );
}

export default AmbientUtilityGate;
